//@ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  Grid,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  Circle,
} from "@react-google-maps/api";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import SaveIcon from "@mui/icons-material/Save";
import { toast, ToastContainer } from "react-toastify";
import api from "../../utils/Url";
import CustomLabel from "../../CustomLable";

const containerStyle = {
  width: "100%",
  height: "500px",
};

export default function Geofacing() {
  const { t } = useTranslation();

  const mapRef = useRef<any>(null);
  const drawingManagerRef = useRef<any>(null);

  const [zones, setZones] = useState<any[]>([]);
  const [columns, setColumns] = useState<GridColDef[]>([]);
  const [visible, setVisible] = useState(false);
  const [circles, setCircles] = useState<any[]>([]);
  const [polygon, setPolygon] = useState<any>(null);

  const [center] = useState({ lat: 26.447965, lng: 80.3432 });

  /* ---------------- FORM ---------------- */
  const formik = useFormik({
    initialValues: {
      fenceId: null,
      lattitude: 0,
      longitude: 0,
      radius: 0,
      fenceName: "",
      dateSave: new Date().toISOString(),
      companyId: 1,
      polycord: "",
    },
    onSubmit: async (values) => {
      const payload = {
        data: [
          {
            fenceId: values.fenceId,
            lattitude: values.lattitude,
            longitude: values.longitude,
            radius: values.radius,
            fenceName: values.fenceName,
            dateSave: values.dateSave,
            companyId: values.companyId,
            polycord: values.polycord,
          },
        ],
      };

      try {
        await api.post(
          "Adm/SaveGeofending",
          payload
        );
        toast.success("Geo-fence saved successfully");
        removeShapes();
        formik.resetForm();
      } catch {
        toast.error("Failed to save geo-fence");
      }
    },
  });

  /* ---------------- GET GEOFENCES ---------------- */
  const fetchZonesData = async () => {
    const payload = {
      fenceName: null,
      startDate: null,
      endDate: null,
    };

    const res = await api.post(
      "Adm/GetGeofencing",
      payload
    );

    const data = res?.data?.data?.data || [];

    const mapped = data.map((z: any, i: number) => ({
      id: i + 1,
      serialNo: i + 1,
      fenceName: z.fenceName,
      lattitude: z.lattitude,
      longitude: z.longitude,
      radius: z.radius,
      polycord: z.polycord,
    }));

    setZones(mapped);

    setColumns([
      { field: "serialNo", headerName: t("text.SrNo"), flex: 0.4 },
      { field: "fenceName", headerName: t("text.FenceName"), flex: 1 },
      { field: "lattitude", headerName: t("text.Latitute"), flex: 1 },
      { field: "longitude", headerName: t("text.Longitude"), flex: 1 },
      { field: "radius", headerName: t("text.Radius"), flex: 1 },
      { field: "polycord", headerName: t("text.Polygon"), flex: 1 },
    ]);
  };

  /* ---------------- DRAWING MANAGER ---------------- */
  const initializeDrawingManager = (map: any) => {
    if (drawingManagerRef.current) return;

    drawingManagerRef.current =
      new window.google.maps.drawing.DrawingManager({
        drawingMode: window.google.maps.drawing.OverlayType.CIRCLE,
        drawingControl: true,
        drawingControlOptions: {
          position: window.google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ["circle", "polygon"],
        },
      });

    drawingManagerRef.current.setMap(map);

    window.google.maps.event.addListener(
      drawingManagerRef.current,
      "circlecomplete",
      (circle: any) => {
        setCircles((prev) => [...prev, circle]);
        const c = circle.getCenter();
        formik.setFieldValue("lattitude", c.lat());
        formik.setFieldValue("longitude", c.lng());
        formik.setFieldValue("radius", circle.getRadius());
      }
    );

    window.google.maps.event.addListener(
      drawingManagerRef.current,
      "polygoncomplete",
      (poly: any) => {
        setPolygon(poly);
        const coords: string[] = [];
        poly.getPath().forEach((p: any) =>
          coords.push(`${p.lng()},${p.lat()}`)
        );
        formik.setFieldValue("polycord", coords.join(" "));
      }
    );
  };

  const cleanupDrawingManager = () => {
    drawingManagerRef.current?.setMap(null);
    drawingManagerRef.current = null;
  };

  const removeShapes = () => {
    circles.forEach((c) => c.setMap(null));
    polygon?.setMap(null);
    setCircles([]);
    setPolygon(null);
    formik.setFieldValue("polycord", "");
  };

  const handleCheckboxChange = (e: any) => {
    setVisible(e.target.checked);
    if (e.target.checked) fetchZonesData();
  };

  /* ---------------- JSX ---------------- */
  return (
    <div>
      <ToastContainer />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={12}
            onLoad={(map) => {
              mapRef.current = map;
              initializeDrawingManager(map);
            }}
            onUnmount={cleanupDrawingManager}
          >
            {circles.map((c, i) => (
              <Circle
                key={i}
                center={c.getCenter()}
                radius={c.getRadius()}
                options={{
                  fillColor: "rgba(0,255,0,0.3)",
                  strokeColor: "green",
                  strokeWeight: 1,
                }}
              />
            ))}
          </GoogleMap>

          <Button onClick={removeShapes}>Remove Circle</Button>
        </Grid>
      </Grid>

      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid item xs={6}>
            <TextField
              name="lattitude"
              type="number"
              value={formik.values.lattitude}
              onChange={formik.handleChange}
              label={<CustomLabel text={t("text.Latitude")} />}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              name="longitude"
              type="number"
              value={formik.values.longitude}
              onChange={formik.handleChange}
              label={<CustomLabel text={t("text.Longitude")} />}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              name="radius"
              type="number"
              value={formik.values.radius}
              onChange={formik.handleChange}
              label={<CustomLabel text={t("text.Radius")} />}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              name="fenceName"
              value={formik.values.fenceName}
              onChange={formik.handleChange}
              label={<CustomLabel text={t("text.FenceName")} />}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid item xs={4}>
            <Button
              type="submit"
              fullWidth
              startIcon={<SaveIcon />}
              style={{
                backgroundColor: "var(--header-background)",
                color: "white",
              }}
            >
              Save Fencing
            </Button>
          </Grid>

          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox checked={visible} onChange={handleCheckboxChange} />
              }
              label="Show Existing"
            />
          </Grid>

          {visible && (
            <Grid item xs={12} sx={{ mt: 3 }}>
              <DataGrid
                rows={zones}
                columns={columns}
                autoHeight
                pageSizeOptions={[5, 10, 25]}
                initialState={{
                  pagination: { paginationModel: { pageSize: 5 } },
                }}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#42b6f5",
                    color: "white",
                  },
                }}
              />
            </Grid>
          )}
        </Grid>
      </form>
    </div>
  );
}





























// import React, { useEffect, useRef, useState } from "react";
// import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Card,
//   Grid,
//   CardContent,
//   Typography,
//   Divider,
//   Switch,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   TextField,
//   DialogActions,
//   Stack,
//   Paper,
//   CircularProgress,
//   Select,
//   MenuItem,
//   Radio,
//   FormLabel,
//   Autocomplete,
//   Checkbox,
//   ListItemText,
//   FormControlLabel,
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import api from "../../utils/Url";
// import Box from "@mui/material/Box";

// import { toast, ToastContainer } from "react-toastify";
// import {
//   Circle,
//   GoogleMap,
//   InfoWindow,
//   LoadScript,
//   Marker,
//   DrawingManager,
// } from "@react-google-maps/api";
// import CustomLabel from "../../CustomLable";
// import { useFormik } from "formik";
// import SaveIcon from "@mui/icons-material/Save";

// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
// }

// export default function Geofacing() {
//   const { t } = useTranslation();

//   const navigate = useNavigate();

//   const [zones, setZones] = useState([]);
//   const [columns, setColumns] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(false);

//   const [visible, setVisible] = useState(false);

//   const [circles, setCircles] = useState<any[]>([]);

//   useEffect(() => {
//     getDashData();

//     // fetchZonesData();
//   }, []);

//   const formatTrackTime = (tracktime: string) => {
//     const trackTime = new Date(tracktime);

//     const day = trackTime.getDate().toString().padStart(2, "0");
//     const month = (trackTime.getMonth() + 1).toString().padStart(2, "0");
//     const year = trackTime.getFullYear();
//     const hours = trackTime.getHours().toString().padStart(2, "0");
//     const minutes = trackTime.getMinutes().toString().padStart(2, "0");
//     const seconds = trackTime.getSeconds().toString().padStart(2, "0");

//     return `${day}-${month}-${year} (Time:- ${hours}:${minutes}:${seconds})`;
//   };

//   const [vehicles, setVehicles] = useState<any>([]);
//   const [activeVehicle, setActiveVehicle] = useState<any>(null);
//   const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
//   const mapRef: any = useRef(null);
//   const drawingManagerRef = useRef<any>(null);
//   const [circle, setCircle] = useState<any>(null);
//   const [polygon, setPolygon] = useState<any>(null);

//   // Fetch the vehicle data from API
//   // Fetch the vehicle data from API
//   const getDashData = () => {
//     const collectData = {
//       fencId: null,
//       fenceName: null,
//       lsVehType: [],
//       lsVehNos: [],
//       dateSaveFr: new Date().toISOString(),
//       dateSaveTo: new Date().toISOString(),
//     };

//     api.post(`NTRead/GetDashData`, collectData).then((res) => {
//       const arr = res?.data?.data?.listNTSumm.map((item: any) => ({
//         vehicleNo: item.vehicleno || "No ID",
//         lat: item.lattitude,
//         lng: item.longitude,
//         id: item.id,
//         speed: item.speed,
//         tracktime: formatTrackTime(item.tracktime),
//         departmentname: item.departmentname,
//         empName: item.empName,
//         vehicleTypename: item.vehicleTypename,

//         icon:
//           item.speed === 0
//             ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
//             : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
//       }));
//       setVehicles(arr);
//       setCenter(calculateCenter(arr));

//       if (arr.length > 0) {
//         adjustZoomLevel(arr);
//       }
//     });
//   };

//   const calculateCenter = (vehicles: any) => {
//     if (vehicles.length === 0) {
//       return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
//     }

//     const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
//     const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

//     const avgLat =
//       latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
//     const avgLng =
//       longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
//       longitudes.length;

//     return { lat: avgLat, lng: avgLng }; // Return the center point
//   };

//   // Adjust the zoom level based on the spread of the vehicles
//   const adjustZoomLevel = (vehicles: any) => {
//     const bounds = new window.google.maps.LatLngBounds();

//     vehicles.forEach((vehicle: any) => {
//       bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
//     });

//     if (mapRef.current) {
//       mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
//     }
//   };

//   const handleMarkerMouseOver = (vehicle: any) => {
//     setActiveVehicle(vehicle);
//   };

//   const handleMarkerMouseOut = () => {
//     setActiveVehicle(null);
//   };

//   const initializeDrawingManager = (map: any) => {
//     if (map && !drawingManagerRef.current) {
//       drawingManagerRef.current = new window.google.maps.drawing.DrawingManager({
//         drawingMode: window.google.maps.drawing.OverlayType.CIRCLE,
//         drawingControl: true,
//         drawingControlOptions: {
//           position: window.google.maps.ControlPosition.TOP_CENTER,
//           drawingModes: [
//             window.google.maps.drawing.OverlayType.CIRCLE,
//             window.google.maps.drawing.OverlayType.POLYGON,
//           ],
//         },
//       });
  
//       drawingManagerRef.current.setMap(map);
  
//       window.google.maps.event.addListener(
//         drawingManagerRef.current,
//         "circlecomplete",
//         (newCircle: any) => {
//           setCircles((prevCircles) => [...prevCircles, newCircle]); // Add the new circle to the circles array
  
//           const center = newCircle.getCenter();
//           const radius = newCircle.getRadius();
  
//           formik.setFieldValue("lattitude", center.lat());
//           formik.setFieldValue("longitude", center.lng());
//           formik.setFieldValue("radius", radius);
  
//           console.log("Circle drawn:", { latitude: center.lat(), longitude: center.lng(), radius });
//         }
//       );
  
//       window.google.maps.event.addListener(
//         drawingManagerRef.current,
//         "polygoncomplete",
//         (newPolygon: any) => {
//           setPolygon(newPolygon);
//           const path = newPolygon.getPath();
//           const coordinates: any = [];
  
//           path.forEach((latLng: any) => {
//             coordinates.push(`${latLng.lng()},${latLng.lat()}`);
//           });
  
//           const coordinatesString = coordinates.join(" ");
//           formik.setFieldValue("polycord", coordinatesString);
  
//           console.log("Polygon drawn:", coordinatesString);
//         }
//       );
  
//       console.log("Drawing Manager initialized");
//     }
//   };
  
//   // Cleanup function to remove DrawingManager when unmounted
//   const cleanupDrawingManager = () => {
//     if (drawingManagerRef.current) {
//       drawingManagerRef.current.setMap(null);
//       drawingManagerRef.current = null;
//       console.log("Drawing Manager cleaned up");
//     }
//   };
  
//   // Function to remove all circles one by one
//   const removeCircle = () => {
//     // Loop through all circles and remove them
//     circles.forEach((circle) => {
//       circle.setMap(null); // Remove circle from the map
//     });
  
//     // Clear the circles from the state
//     setCircles([]);
  
//     // If there is a polygon, remove it as well
//     if (polygon) {
//       polygon.setMap(null);
//       setPolygon(null);
//       formik.setFieldValue("polycord", "");
//     }
//   };
  
//   useEffect(() => {
//     if (mapRef.current) {
//       initializeDrawingManager(mapRef.current); // Initialize DrawingManager
//     }
  
//     return cleanupDrawingManager; // Cleanup when component unmounts
//   }, []); // Empty dependency ar


  

//   const formik = useFormik({
//     initialValues: {
//       activeClass: "",
//       all: true,
//       showExisting: true,
//       isSuccess: true,
//       message: "",
//       eScarp: true,
//       eScarpPrevValue: "",
//       css: "",
//       fenceId: 0,
//       lattitude: 0,
//       longitude: 0,
//       radius: 0,
//       fenceName: "",

//       dateSave: new Date().toISOString(),
//       companyId: 1,

//       polycord: "",
//       slattitude: "",
//       slongitude: "",
//       vehicleNo: "",

//       dateTimeV: new Date().toISOString(),

//       flag: true,
//       srno: -1,
//     },
//     onSubmit: async (values) => {
//       const response = await api.post(`GeoFencing/AddUpdateGeoFencing`, values);

//       try {
//         toast.success(response.data.mesg);
//       } catch (error) {
//         toast.error(response.data.mesg);

//       if (response.data.status) {
//         removeCircle();
//         formik.resetForm();
//         setTimeout(() => {
//           toast.success(response.data.message);
//         }, 500);
//       } else {
//         toast.error(response.data.message);

//       }
//     }
//   }
//   });

//   const fetchZonesData = async () => {
//     try {
//       const collectData = {
//         orderby: "",
//         pageNo: 0,
//         pageSize: 0,
//         intnotnullvalue1: 0,
//         userId: "",

//         str1: "",
//         str2: "",
//         str3: "",
//         str4: "",
//         str5: "",
//         intvalue1: 0,
//         intvalue2: 0,
//         intvalue3: 0,
//         intvalue4: 0,
//         intnotnullvalue2: 0,
//         intnotnullvalue3: 0,
//         date1: new Date().toISOString(),
//         date2: new Date().toISOString(),
//         date3: new Date().toISOString(),
//         date4: new Date().toISOString(),
//         dec1: 0,
//         dec2: 0,
//         dec3: 0,
//         dec4: 0,
//         flag: true,
//         data: "",
//         success: true,
//         error: "",
//         selectPerindex: 0,
//         show: true,
//       };
//       const response = await api.post(`GeoFencing/GetGeofencing`, collectData);
//       const data = response?.data?.data;

//       // console.log("HourData", data);
//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones(zonesWithIds);

//       // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
//       setIsLoading(false);

//       if (data.length > 0) {
//         const columns: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//             // headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "fenceName",
//             headerName: t("text.FenceName"),
//             flex: 1,
//             // headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "lattitude",
//             headerName: t("text.Latitute"),
//             flex: 1,
//             // headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",
//           },

//           {
//             field: "longitude",
//             headerName: t("text.Longitude"),
//             flex: 1,
//             // headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",
//           },

//           {
//             field: "radius",
//             headerName: t("text.Radius"),
//             flex: 1,
//             // headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",
//           },

//           {
//             field: "polycord",
//             headerName: t("text.Polygon"),
//             flex: 1,
//             // headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",
//           },
//         ];
//         setColumns(columns as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns = columns.map((column: any) => ({
//     ...column,
//   }));


//   const styles = `
//   .wrap-text {
//     white-space: normal !important;
//     word-wrap: break-word !important;
//     overflow-wrap: break-word !important;
//   }
// `;

//   document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);


//   const handleCheckboxChange = (event: any) => {
//     setVisible(event.target.checked);
//     fetchZonesData();
//   };

//   return (
//     <div>
//       <Grid
//         container
//         spacing={2}
//         style={{
//           // backgroundColor:'red',
//           //marginTop: "2vh",
//         }}
//       >
//         <Grid item xs={12} sm={12} lg={12}>
//           <div
//             style={{
//               border: "1px solid black",
//               boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//             }}
//           >
//             {/* <LoadScript
//               googleMapsApiKey="AIzaSyDxp8MamOh_0gBNHBq4m3bgCIgksc4YYgQ"
//               libraries={["drawing"]}
//             > */}
//             <GoogleMap
//               mapContainerStyle={containerStyle}
//               center={center}
//               zoom={12}
//               onLoad={(map: any) => {
//                 mapRef.current = map; // Set the map reference
//                 initializeDrawingManager(map); // Initialize DrawingManager after map load
//                 console.log("Google Map Loaded");
//               }}
//               onUnmount={cleanupDrawingManager}
//             >
//               {vehicles.map((vehicle: any) => (
//                 <Marker
//                   key={vehicle.id}
//                   position={{ lat: vehicle.lat, lng: vehicle.lng }}
//                   icon={{
//                     url: vehicle.icon,
//                     scaledSize: new window.google.maps.Size(50, 50),
//                     origin: new window.google.maps.Point(0, 0),
//                     anchor: new window.google.maps.Point(25, 25),
//                   }}
//                   onMouseOver={() => handleMarkerMouseOver(vehicle)}
//                   onMouseOut={handleMarkerMouseOut}
//                 >
//                   {activeVehicle && activeVehicle.id === vehicle.id && (
//                     <InfoWindow>
//                       <div>
//                         <div>
//                           <strong>Vehicle No: </strong>
//                           {vehicle.vehicleNo}
//                         </div>
//                         <div>
//                           <strong>Vehicle Type: </strong>
//                           {vehicle.vehicleTypename}
//                         </div>
//                         <div>
//                           <strong>Speed: </strong>
//                           {vehicle.speed}
//                         </div>
//                         <div>
//                           <strong>Department: </strong>
//                           {vehicle.departmentname}
//                         </div>
//                         <div>
//                           <strong>Date & Time: </strong>
//                           {vehicle.tracktime}
//                         </div>
//                         <div>
//                           <strong>Driver: </strong>
//                           {vehicle.empName}
//                         </div>
//                       </div>
//                     </InfoWindow>
//                   )}
//                 </Marker>
//               ))}

//               {circle && (
//                 <Circle
//                   center={circle.getCenter()}
//                   radius={circle.getRadius()}
//                   options={{
//                     fillColor: "rgba(0, 255, 0, 0.3)",
//                     strokeColor: "green",
//                     strokeWeight: 1,
//                   }}
//                 />
//               )}
//             </GoogleMap>
//             {/* </LoadScript> */}

//             <button
//               onClick={() => {
//                 removeCircle();
//                 formik.resetForm();
//               }}
//             >
//               Remove Circle
//             </button>
//           </div>
//         </Grid>
//       </Grid>
//       <form onSubmit={formik.handleSubmit}>
//         <ToastContainer />
//         <Grid item xs={12} container spacing={2} sx={{ marginTop: "3%" }}>
//           <Grid xs={12} sm={6} md={6} item>
//             <TextField
//               type="number"
//               id="lattitude"
//               name="lattitude"
//               label={<CustomLabel text={t("text.Latitude")} required={false} />}
//               value={formik.values.lattitude}
//               placeholder={t("text.Latitude")}
//               size="small"
//               fullWidth
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               onFocus={(e) => e.target.select()}
//             />
//           </Grid>

//           <Grid xs={12} sm={6} md={6} item>
//             <TextField
//               type="number"
//               id="longitude"
//               name="longitude"
//               label={
//                 <CustomLabel text={t("text.Longitude")} required={false} />
//               }
//               value={formik.values.longitude}
//               placeholder={t("text.Longitude")}
//               size="small"
//               fullWidth
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               onFocus={(e) => e.target.select()}
//             />
//           </Grid>

//           <Grid xs={12} sm={6} md={6} item>
//             <TextField
//               type="number"
//               id="radius"
//               name="radius"
//               label={<CustomLabel text={t("text.Radius")} required={false} />}
//               value={formik.values.radius}
//               placeholder={t("text.Radius")}
//               size="small"
//               fullWidth
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               onFocus={(e) => e.target.select()}
//             />
//           </Grid>

//           <Grid xs={12} sm={6} md={6} item>
//             <TextField
//               id="fenceName"
//               name="fenceName"
//               label={
//                 <CustomLabel text={t("text.FenceName")} required={false} />
//               }
//               value={formik.values.fenceName}
//               placeholder={t("text.FenceName")}
//               size="small"
//               fullWidth
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//             />
//           </Grid>

//           <Grid xs={12} sm={4} md={4} item>
//             <Button
//               type="submit"
//               fullWidth
//               style={{
//                 backgroundColor: `var(--header-background)`,
//                 color: "white",
//                 marginTop: "10px",
//               }}
//               startIcon={<SaveIcon />}
//             >
//               save Fencing
//             </Button>
//           </Grid>

//           <Grid xs={12} sm={4} md={4} item sx={{ marginTop: ".5%" }}>
//             <FormControlLabel
//               control={
//                 <Checkbox checked={visible} onChange={handleCheckboxChange} />
//               }
//               label="Show Existing"
//             />
//           </Grid>

//           {visible && (
//             <Grid xs={12} sm={12} md={12} item sx={{ marginTop: "3%" }}>
//               <DataGrid
//                 rows={zones}
//                 columns={adjustedColumns}
//                 rowSpacingType="border"
//                 autoHeight
//                 // slots={{
//                 //   toolbar: GridToolbar,
//                 // }}
//                 pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//                   value: size,
//                   label: `${size}`,
//                 }))}
//                 initialState={{
//                   pagination: { paginationModel: { pageSize: 5 } },
//                 }}
//                 slotProps={{
//                   toolbar: {
//                     showQuickFilter: true,
//                   },
//                 }}
//                 sx={{
//                   border: 0,
//                   "& .MuiDataGrid-columnHeaders": {
//                     backgroundColor: "#42b6f5", // Header background color
//                     color: "white", // Header text color
//                   },
//                   "& .MuiDataGrid-columnHeaderTitle": {
//                     color: "white", // Header title text color
//                   },
//                   "& .MuiDataGrid-cell": {
//                     whiteSpace: "normal", 
//                     wordWrap: "break-word",
//                     overflowWrap: "break-word", 
//                   },
//                 }}
//               />
//             </Grid>
//           )}
//         </Grid>
//       </form>
//     </div>
//   );
// }
